import { domain } from '../d-man';

export type User = {
    id: string;
    firstName: string;
    lastName: string;
    userName: string;
    email: string;
    emailConfirmed: boolean;
};

/**
 * @param username matches the username only
 * @param search   matches username, first name, last name or email
 */
export function useGetUsers(skip?: number, take?: number, username?: string, search?: string) {
    return domain.useGet<User[]>('/users', {
        requestConfig: {
            queryParams: {
                skip,
                take,
                username,
                search,
            },
        },
    });
}

export function useGetUser(userId: string) {
    return domain.useGet<User>(`/users/${userId}`);
}
